import { render, staticRenderFns } from "./ClarifyList.vue?vue&type=template&id=005a0b88&scoped=true&"
import script from "./ClarifyList.vue?vue&type=script&lang=js&"
export * from "./ClarifyList.vue?vue&type=script&lang=js&"
import style0 from "./ClarifyList.vue?vue&type=style&index=0&id=005a0b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005a0b88",
  null
  
)

export default component.exports